.root {
    position: relative;
    width: 9rem;
    height: 9rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.loading {
    opacity: 0.45;
}

.ring {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    /* Force the browser to use high-quality vector rendering rather than
       speed-optimized rasterization, which can leave the stroked edges
       looking jagged at the rendered size. */
    shape-rendering: geometricPrecision;
    /* Promote to its own layer so the GPU rasterizes the SVG (including the
       drop shadow filter) with sub-pixel precision. */
    transform: translateZ(0);
}

/* Animate the colored arc filling from 0 to its target on load. The track
   circle's stroke-dashoffset never changes, so this transition only
   manifests on the colored section. */
.arc {
    transition: stroke-dashoffset 900ms cubic-bezier(0.22, 1, 0.36, 1);
}

@media (prefers-reduced-motion: reduce) {
    .arc {
        transition: none;
    }
}

.center {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}
